import React from "react";
import { Redirect } from "react-router-dom";
import lssRoutes from './views/lss/LssRoutes';
import RaftRoutes from './views/raft/RaftRoutes';
import ventasRoutes from './views/venta-activos/VentasRoutes';
import educationalReimbursementRoutes from './views/educational-reimbursement/educationalReimbursementRoutes';
import sykesHomeRoutes from './views/sykesHome/sykesHomeRoutes';
import sessionRoutes from "./views/sessions/SessionRoutes";
import growthOpportunitiesRoutes from "./views/growth-opportunities/GrowthOpportunitiesRoutes";
import userRoutes from "./views/user/UserRoutes";
import benefitsRoutes from "./views/benefits/BenefitsRoutes";
import ExtracurricularCourses from "./views/ExtracurricularCourses/ExtracurricularCoursesRoutes"
import ConfigurationMessages from "./views/ConfigurationMessages/ConfigurationMessagesRoutes"
import MyLocation from "./views/MyLocation/MyLocationRoutes"
import Medical from "./views/MedicalAppointment/MedicalAppointmentRoutes"
import Schedule from "./views/ScheduleChange/ScheduleChangeRoutes"
import Certificates from "./views/Certificates/CertificatesRoute"
import Transportation from "./views/Transportation/TransportationRoutes"
import menuRoutes from "./views/menuHome/MenuRoutes";
import permissionsRoutes from "./views/permissions/PermissionsRoutes";
import NewsletterRoutes from "./views/newsletters/NewsletterRoutes";
import personalDaysRoutes from "./views/personalDays/PersonalDaysRoutes";
import PayrollRoutes from "./views/payroll/PayrollRoutes";
import CafeteriaRoutes from "./views/cafeteria/CafeteriaRoutes";

/*
  Required if you are going to use Evelynn Landing page
  https://themeforest.net/item/react-landing-material-ui-react-saasproduct-landing-page/23847400
*/


const redirectRoute = [
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/Inicio" />
    // component: () => <Redirect to="/dashboard/analytics" />
  }
];

const errorRoute = [
  {
    component: () => <Redirect to="/session/404" />
  }
];

const routes = [
  ...sessionRoutes,
  ...educationalReimbursementRoutes,
  ...sykesHomeRoutes,
  ...growthOpportunitiesRoutes,
  ...userRoutes,
  ...ventasRoutes,
  ...benefitsRoutes,
  ...ExtracurricularCourses,
  ...ConfigurationMessages,
  ...MyLocation,
  ...Medical,
  ...Schedule,
  ...Certificates,
  ...Transportation,
  ...lssRoutes,
  ...RaftRoutes,
  ...permissionsRoutes,
  ...menuRoutes,
  ...NewsletterRoutes,
  ...personalDaysRoutes,
  ...PayrollRoutes,
  ...CafeteriaRoutes,
  ...redirectRoute,
  ...errorRoute,
];

export default routes;
